<script setup lang="ts">
import { usePlayerCreditStore } from '@/stores/playerCreditStore.ts'
import GFBalanceSheetItem from '@/components/Sections/Government/Finances/Elements/GFBalanceSheetItem.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Stores / models
 */
const playerCreditStore = usePlayerCreditStore()
</script>

<template>
  <div>
    <StandardCard :title="t('government.finances.balanceSheet.title')" top-padding="0" bottom-padding="1">
      <div>{{ t('government.finances.balanceSheet.help') }}</div>
      <div class="rounded p-2 mt-2 sunken">
        <GFBalanceSheetItem
          :amount="playerCreditStore.playerCreditBalanceSheet.planets"
          :header="t('government.finances.balanceSheet.categories.planets')"
          subheader=""
          type="planets"
        />
        <GFBalanceSheetItem
          :amount="playerCreditStore.playerCreditBalanceSheet.ministers"
          :header="t('government.finances.balanceSheet.categories.ministers')"
          subheader=""
          type="ministers"
        />
        <GFBalanceSheetItem
          :amount="playerCreditStore.playerCreditBalanceSheet.oreTrades"
          :header="t('government.finances.balanceSheet.categories.oreTrade')"
          subheader=""
          type="oreTrades"
        />
        <GFBalanceSheetItem :amount="0" :header="t('government.finances.balanceSheet.categories.vips')" subheader="" type="vips" />
        <GFBalanceSheetItem
          :amount="playerCreditStore.playerCreditBalanceSheet.spyCosts"
          :header="t('government.finances.balanceSheet.categories.spies')"
          subheader=""
          type="spies"
        />
        <GFBalanceSheetItem
          :amount="playerCreditStore.playerCreditBalanceSheet.shipMaintenance"
          :header="t('government.finances.balanceSheet.categories.shipMaintenance')"
          :subheader="t('government.finances.balanceSheet.rounded')"
          type="shipMaintenance"
        />
        <GFBalanceSheetItem
          :amount="playerCreditStore.playerCreditBalanceSheet.commandHierarchyCost"
          :header="t('government.finances.balanceSheet.categories.commandHierarchy')"
          subheader=""
          type="commandHierarchy"
        />
      </div>
      <div class="rounded p-2 mt-2 sunken">
        <GFBalanceSheetItem
          :amount="playerCreditStore.playerCreditBalanceSheet.creditsPerTurn"
          :header="t('government.finances.balanceSheet.creditsPerWeek')"
          :subheader="t('government.finances.balanceSheet.estimated')"
          :total="true"
        />
      </div>
    </StandardCard>
  </div>
</template>

<style scoped lang="scss">
.sunken {
  background: rgba(15, 18, 22, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);
}
</style>
